// @ts-nocheck
export default function zeroPadding(num, len = 2) {
    return (Array(len).join('0') + num).slice(-len);
}
